<div class="ai-hub-form pl-3 mt-3 display-flex">
    <div class="d-flex justify-content-between">
        <div [routerLink]="''" class="cursor-pointer">
            <img src="./assets/img/linkedIn_logo.svg" class="asset-logo" />
            <span class="asset-name">PostGenie</span>
        </div>
        <div>
            <a class="cursor-pointer input-element prefill-container" href="javascript:void(0)">
                <img src="./assets/img/prefill.svg" alt="Prefill data" />
                <span class="prefill" [matMenuTriggerFor]="options"> Prefill sample data </span>
                <mat-menu #options="matMenu">
                    <ng-container *ngFor="let post of postDescriptions; let i = index">
                        <div mat-menu-item (click)="prefillSampleData(i)">
                            <mat-icon>{{ post.icon }}</mat-icon>
                            <span> {{ post.text }}</span>
                        </div>
                    </ng-container>
                </mat-menu>
            </a>
        </div>
    </div>


    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
        <!-- Social Media Platform -->
        <!-- <label>Social Media Platform</label>
        <mat-form-field>
            <mat-select formControlName="platform">
                <mat-option *ngFor="let option of platforms" [value]="option">
                    {{ option }}
                </mat-option>
            </mat-select>
        </mat-form-field> -->

        <!-- Post Description -->
        <div class="aihub__form--control">
            <label>LinkedIn post description *</label>
            <textarea formControlName="postDescription" maxlength="400" placeholder="E.g. LinkedIn post about importance of continuous learning" rows="4" class="w-100"></textarea>
            <small>(Maximum 400 characters)</small>
        </div>

        <!-- Audience -->
        <div class="aihub__form--control">
            <label>Audience</label>
            <input type="text" formControlName="audience" class="w-100" placeholder="E.g. consultants, tax professionals..." />
        </div>

        <!-- Tone -->
        <label>Tone of the post</label>
        <mat-form-field appearance="fill">
            <mat-label>Select...</mat-label>
            <mat-select formControlName="tone">
                <mat-option value="professional">Professional</mat-option>
                <mat-option value="creative">Creative</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Language -->
        <label>Language</label>
        <mat-form-field appearance="fill">
            <mat-label>Select...</mat-label>
            <mat-select formControlName="language">
                <mat-option value="English"> English </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Language -->
        <!-- <label>Language</label>
        <input type="text" formControlName="language" class="w-100 mb-2" placeholder="E.g. German or English" /> -->

        <!-- Options -->
        <!-- <mat-slide-toggle formControlName="emoticons">Include emoticons</mat-slide-toggle> -->
        <!-- <mat-slide-toggle formControlName="hashtags">Hashtags</mat-slide-toggle> -->
        <!-- <mat-slide-toggle formControlName="bulletPoints">Bullet Points</mat-slide-toggle> -->

        <button class="btn btn-primary input-element" type="submit()" [disabled]="!form.value.postDescription || form.value.postDescription == ''">Generate</button>
    </form>
</div>
